import React, { useState } from 'react'
import * as styles from './index.module.css'
import { GradientBorder } from '../commons'
import styled, { css } from 'styled-components'

/* styled component fpr creating Nav links */
const Caret = styled.i`
  border: solid blue;
  margin-left: 4px;
  border-width: 0 2px 2px 0;
  display: inline-block;
  padding: 7px;
  cursor: pointer;
  position: absolute;
  left: 0;
  top: calc(50% + 7px);
  transform: translate(0, -50%);

  ${(props) =>
    props.up &&
    css`
      transform: translate(0, -50%) rotate(-135deg);
      top: calc(50% + 7px);
    `};

  ${(props) =>
    props.down &&
    css`
      transform: translate(0, -50%) rotate(45deg);
      top: calc(50% - 2px);
    `};

  @media (max-width: 1024px) {
    display: none;
  }
`

const RightCaret = styled.i`
  border: solid blue;
  margin-left: 4px;
  border-width: 0 2px 2px 0;
  display: inline-block;
  padding: 7px;
  cursor: pointer;
  position: absolute;
  right: 0;
  top: calc(50% + 7px);
  transform: translate(0, -50%);

  ${(props) =>
    props.up &&
    css`
      transform: translate(0, -50%) rotate(-135deg);
      top: calc(50% + 7px);
    `};

  ${(props) =>
    props.down &&
    css`
      transform: translate(0, -50%) rotate(45deg);
      top: calc(50% - 2px);
    `};

  @media (max-width: 1024px) {
    padding: 5px;
  }

  @media (min-width: 1025px) {
    display: none;
  }
`

const FoldableSection = ({
  title,
  children,
  initiallyOpened = false,
  disableXScroll = false,
}) => {
  const isMobile = typeof window !== `undefined` && window.innerWidth <= 767
  const [opened, setOpened] = useState(initiallyOpened || false)

  let customStyle = {}
  if (!disableXScroll) {
    customStyle['overflowX'] = 'scroll'
  }

  return (
    <div className={`${styles.foldableSection}`} style={customStyle}>
      <div className={`${styles.header}`} onClick={() => setOpened(!opened)}>
        <Caret
          up={opened ? true : false}
          down={!opened ? true : false}
          onClick={() => setOpened(!opened)}
        />

        <RightCaret
          up={opened ? true : false}
          down={!opened ? true : false}
          onClick={() => setOpened(!opened)}
        />

        <div className={styles.title}>{title}</div>
      </div>
      <div className={`${opened ? styles.opened : styles.closed}`}>
        <div className={styles.childrenContainer}>{children}</div>
      </div>
    </div>
  )
}

export default FoldableSection
